import { useCallback, useEffect, useState } from "react";
import { TranslationService } from "../../../services/TranslationService";
import AccountService from "../../../services/AccountService";
import { SubscriptionResponse } from "../../account/entities/AccountResponse";
import { capitalize } from "../../../utils/FormatUtils";
import FloatingPanelService from "../../shared/FloatingPanel";
import { UserListGetResponse } from "../../user/entities/UserListGetResponse";

export const SubscriptionData = () => {
  const [data, setData] = useState<SubscriptionResponse>();
  const [usersData, setUsersData] =
    useState<UserListGetResponse.UserAccountPlan[]>();

  const loadData = async () => {
    const result = await AccountService.getSubscription();
    if (result instanceof Error) {
      return;
    }
    setData(result);
  };

  const loadDataUsers = async () => {
    const result = await AccountService.getUsersByPlan();
    if (result instanceof Error) {
      return;
    }
    setUsersData(result.users);
  };

  const showUsersByPlan = useCallback(() => {
    if (usersData) {
      FloatingPanelService.showPanel({
        children: <UsersByPlan users={usersData} />,
        title:
          TranslationService.translate.Users + " " + (usersData.length || 0),
        width: 1200,
        height: usersData.length === 0 ? 150 : 650,
        position: "center"
      });
    }
  }, [usersData]);

  useEffect(() => {
    loadData();
    loadDataUsers();
  }, []);

  return (
    <>
      <h4 className="mb-2">{TranslationService.translate.DataPlan}</h4>
      <div className="card">
        <div>
          <div className="d-flex mb-2">
            <label className="col-3 me-1">
              {TranslationService.translate.PlanType}:
            </label>
            <b>{capitalize(TranslationService.translate.CustomDataPlan)}</b>
          </div>
          <div className="d-flex mb-2">
            <label className="col-3 me-1">
              {TranslationService.translate.ActiveClientsLimit}:
            </label>
            {capitalize(TranslationService.translate.NoLimit)}s{" "}
            <span>
              {data?.clientcount &&
                "(" +
                  TranslationService.translate.CurrentlyUsing.replace(
                    "{1}",
                    data.clientcount.toString()
                  ) +
                  ")"}
            </span>
          </div>
          <div className="d-flex mb-2 pointer" onClick={showUsersByPlan}>
            <label className="col-3 me-1">
              {TranslationService.translate.ManagementUsersLimit}:
            </label>
            {capitalize(TranslationService.translate.NoLimit)}s{" "}
            <span className="ms-1 btn-link" style={{ fontSize: 13 }}>
              {usersData &&
                "(" +
                  TranslationService.translate.CurrentlyUsing.replace(
                    "{1}",
                    usersData.length.toString()
                  ) +
                  ")"}
              <i className="fa fa-external-link ms-1" aria-hidden="true"></i>
            </span>
          </div>
        </div>
      </div>
    </>
  );
};

const UsersByPlan = ({
  users
}: {
  users: UserListGetResponse.UserAccountPlan[];
}) => {
  if (users?.length === 0) {
    return (
      <div className="d-flex mb-2">
        <h5 className="col m-4">{TranslationService.translate.NotifyUsers}</h5>
      </div>
    );
  }

  return (
    <div className="floatingBody p-4">
      <table className="table">
        <thead>
          <tr>
            <th scope="col">#</th>
            <th scope="col">{TranslationService.translate.Name}</th>
            <th scope="col">{TranslationService.translate.User}</th>
            <th scope="col">
              {TranslationService.translate.Company}:{" "}
              {TranslationService.translate.Profile}
            </th>
          </tr>
        </thead>
        <tbody>
          {users
            .sort((a, b) =>
              a.UserName.toLowerCase() < b.UserName.toLowerCase() ? -1 : 1
            )
            .map((el, i) => (
              <tr key={i}>
                <th scope="row">{i + 1}</th>
                <td>{el.UserName}</td>
                <td>{el.UserEmail}</td>
                <td>
                  {el.Companies?.map((company, j) => (
                    <div key={j}>{company}</div>
                  ))}
                </td>
              </tr>
            ))}
          <tr />
        </tbody>
      </table>
    </div>
  );
};
